import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

import App from './App';
import DefenderTrainee from './pages/projects/DefenderTrainee';
import Deflander from './pages/projects/Deflander';
import DontMessWithUs from './pages/projects/DontMessWithUs';
import HalloweenNightmare from './pages/projects/HalloweenNightmare';
import ISS from './pages/projects/ISS';
import Tank from './pages/projects/Tank';
import ThrownInTheDungeon from './pages/projects/ThrownInTheDungeon';
import Zeldiablo from './pages/projects/Zeldiablo';
import RailTon from './pages/projects/RailTon';
import TheShipwreck from './pages/projects/TheShipwreck';
import Error from './pages/Error';

import {
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements,
  Route
} from 'react-router-dom'

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path='/' errorElement={<Error/>}>
      <Route index element={<App/>}/>
      <Route path='defender-trainee' element={<DefenderTrainee/>}/>
      <Route path='deflander' element={<Deflander/>}/>
      <Route path='dont-mess-with-us' element={<DontMessWithUs/>}/>
      <Route path='halloween-nightmare' element={<HalloweenNightmare/>}/>
      <Route path='iss' element={<ISS/>}/>
      <Route path='tank' element={<Tank/>}/>
      <Route path='thrown-in-the-dungeon' element={<ThrownInTheDungeon/>}/>
      <Route path='zeldiablo' element={<Zeldiablo/>}/>
      <Route path='railton' element={<RailTon/>}/>
      <Route path='the-shipwreck' element={<TheShipwreck/>}/>
    </Route>
  )
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router}/>
  </React.StrictMode>
);
